<div fxLayout="column" class="profileGreeting">
  <div fxLayout="row" class="pageTitle" style="font-family: 'Century Gothic', sans-serif !important; font-size:28px;">
    {{welcomeMessage}}, {{user.firstName}} {{user.lastName}}
  </div>
  <div fxLayout="row">Συμπληρώστε ηλεκτρονικά τις δηλώσεις εγγραφής σε υπηρεσίες, δραστηριότητες κτλ</div>
</div>
